var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultWallpaperForViewWheel(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "url(#paint0_angular_1035_11227)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_1035_11227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720 450) rotate(90) scale(450 720)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#CCFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F7FED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FDCFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884095,
    stopColor: "#F5EEDE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultWallpaperForViewWheel);
export default __webpack_public_path__ + "static/media/defaultWallpaperForViewWheel.1ec0f1cd986c96bdd8c2046c8a1b8e91.svg";
export { ForwardRef as ReactComponent };